import React, { useState } from 'react';
import UnauthenticatedPageContainer from './YSaatioUnauthenticatedPageContainer';
import YSaatioForgotPasswordStep from './YSaatioForgotPasswordStep';
import YSaatioNewPasswordStep from './YSaatioNewPasswordStep';

const YSaatioResetPasswordPage: React.FC = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState<string>('');

  const handleResetCodeSent = (email: string) => {
    setStep(2);
    setEmail(email);
  };

  const handleNewCode = () => {
    setStep(1);
    setEmail('');
  };

  return (
    <UnauthenticatedPageContainer>
      {step === 1 && <YSaatioForgotPasswordStep onResetCodeSent={handleResetCodeSent} />}
      {step === 2 && <YSaatioNewPasswordStep email={email} onClickNewCode={handleNewCode} />}
    </UnauthenticatedPageContainer>
  );
};

export default YSaatioResetPasswordPage;
